import { Injectable } from '@angular/core';

import { AppcmsService } from 'src/app/services/core/appcms.service';
import { BasketService } from 'src/app/services/ecommerce/basket.service';
import { BrowserService } from 'src/app/services/utils/browser.service';
import { DeviceService } from 'src/app/services/core/device.service';

@Injectable({
  providedIn: 'root'
})
export class KlarnaService {

  paymentOptions: any;

  constructor(
    private AppCMS: AppcmsService,
    private basket: BasketService,
    private browser: BrowserService,
    private device: DeviceService,
  ) {

  }

  buildKlarnaHiddenInputs(data: any, key: string) {
    if (!data) {
      return;
    }
    if (typeof data === 'string') {
      return '<input type="hidden" name="' + key + '" value="' + data + '" />';
    } else
      if (data instanceof Array) {
        let html = '';
        data.forEach((dataItem: any, index: number) => {
          if (dataItem) {
            if (typeof dataItem == 'object') {
              Object.keys(dataItem).forEach((dataSubItemKey: any) => {
                if (data[index][dataSubItemKey]) {
                  if (typeof data[index][dataSubItemKey] == 'object') {
                    Object.keys(data[index][dataSubItemKey]).forEach((dataSubSubItemKey: any) => {
                      if (data[index][dataSubItemKey][dataSubSubItemKey]) {
                        if (typeof data[index][dataSubItemKey][dataSubSubItemKey] == 'object') {
                          Object.keys(data[index][dataSubItemKey][dataSubSubItemKey]).forEach((dataSubSubSubItemKey: any) => {
                            if (data[index][dataSubItemKey][dataSubSubItemKey][dataSubSubSubItemKey]) {
                              html += '<input type="hidden" name="' + key + '[' + index + '][' + dataSubItemKey + '][' + dataSubSubItemKey + '][' + dataSubSubSubItemKey + ']" value="' + data[index][dataSubItemKey][dataSubSubItemKey][dataSubSubSubItemKey] + '" />';
                            }
                          });
                        } else {
                          html += '<input type="hidden" name="' + key + '[' + index + '][' + dataSubItemKey + ']" value="' + data[index][dataSubItemKey] + '" />';
                        }
                        html += '<input type="hidden" name="' + key + '[' + index + '][' + dataSubItemKey + '][' + dataSubSubItemKey + ']" value="' + data[index][dataSubItemKey][dataSubSubItemKey] + '" />';
                      }
                    });
                  } else {
                    html += '<input type="hidden" name="' + key + '[' + index + '][' + dataSubItemKey + ']" value="' + data[index][dataSubItemKey] + '" />';
                  }
                }
              });
            } else {
              html += '<input type="hidden" name="' + key + '[' + index + ']" value="' + dataItem + '" />';
            }
          }
        });
        return html;
      } else
        if (typeof data === 'object') {
          let html = '';

          Object.keys(data).forEach((dataItemKey: any) => {
            if (!data[dataItemKey]) {
              return;
            }
            if (typeof data[dataItemKey] == 'object') {
              Object.keys(data[dataItemKey]).forEach((dataSubItemKey: any) => {
                if (data[dataItemKey][dataSubItemKey]) {
                  html += '<input type="hidden" name="' + key + '[' + dataItemKey + '][' + dataSubItemKey + ']" value="' + data[dataItemKey][dataSubItemKey] + '" />';
                }
              });
            } else
              if (data[dataItemKey]) {
                html += '<input type="hidden" name="' + key + '[' + dataItemKey + ']" value="' + data[dataItemKey] + '" />';
              }
          });
          
          return html;
        } else {
          console.warn('unknown klarna hidden input type', data, key);
          return;
        }
  }


  buildKlarnaPageContent(Params: any) {
    let inputs: string = '';

    if(typeof Params === 'object') {
      Object.keys(Params).forEach((key: string) => {
        inputs += this.buildKlarnaHiddenInputs(Params[key], key)
      });
    }

    return '<html><head></head><body>' +
      '<form id="form" action="' + this.AppCMS.getApiUrl() + '/payments/klarna/create.json" method="post">' + inputs + '</form>' +
      '<script type="text/javascript">document.getElementById("form").submit();</script>' +
      '</body></html>';
  }

  getPaymentOptions() {
    return this.paymentOptions;
  }

  async pay() {

    let Articles = [];

    const basketInfo: basketInfo = await this.basket.calculateBasketInfo();
    const basketStorage: any = await this.basket.getBasket();
    const paymentOptions: any = this.getPaymentOptions();

    if(basketStorage) {
      basketStorage.forEach((Article: any) => {
        Articles.push(this.basket.toBasketItem(Article));
      });
    }
    
    const Params = {
      articles: Articles,
      basketInfo: basketInfo,
      total: basketInfo.price_a,
      device: this.device.getDeviceUid(),
      apiUrl: this.AppCMS.getApiUrl(),
      paymentMethod: paymentOptions.paymentMethod
    };

    const pageContent = this.buildKlarnaPageContent(Params);
    const pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);

    const browserWindow = this.browser.create(
      pageContentUrl,
    );
    
  }

  setPaymentOptions(paymentOptions: any) {
    this.paymentOptions = paymentOptions;
  } 

}
